import { pipe } from 'fp-ts/lib/function';
import { getOrThrow } from '../../util/either';
import { PercentageFromPointsString } from '@silo/utils';

/**
 * If max LTV is below this threshold, then the asset is considered as disabled collateral.
 *
 * Specified in points: '1' = 1%
 */
const DISABLED_COLLATERAL_THRESHOLD = pipe('1', PercentageFromPointsString.decode, getOrThrow);

/**
 * @deprecated use `getIsDisabledCollateral` from `@silo/utils`
 */
export const isDisabledCollateral = (maximumLTV: bigint) => maximumLTV <= DISABLED_COLLATERAL_THRESHOLD.value;
